import {Reports} from 'src/internal/errors/reports.client';

export default Reports;
